<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.225 4.5V19.5M12.6 9.225L15.3 12L12.6 14.775M4.5 6.375C4.5 5.85 4.725 5.4 5.025 5.025C5.4 4.725 5.85 4.5 6.375 4.5H17.625C18.15 4.5 18.6 4.725 18.975 5.025C19.275 5.4 19.5 5.85 19.5 6.375V17.625C19.5 18.15 19.275 18.6 18.975 18.975C18.6 19.275 18.15 19.5 17.625 19.5H6.375C5.85 19.5 5.4 19.275 5.025 18.975C4.65 18.6 4.5 18.15 4.5 17.625V6.375Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
